import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { BaseQueryParams } from 'src/app/app.models';

@Injectable()
export class BERetailInventoryInputService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }

    doGetBaseEtamDatasAction(_queryParams: any) {
        let httpParams = new HttpParams();
        Object.keys(_queryParams).forEach(k => httpParams = httpParams.set(k, _queryParams[k]));
        
        return this._httpClient.get<any[]>(this._apiService.endPoints.doGetBaseEtamDatasAction_BERetail, { params: httpParams })
    }

    doFindArticleBaseEtamAction(codebarre: string) {
        return this._httpClient.get<any>(this._apiService.endPoints.doFindArticleBaseEtamAction_BERetail + '/' + codebarre).toPromise();
    }
}

export class QueryParams_BaseEtamsBERetail extends BaseQueryParams {

}